/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsinvitessent2Inputs */

const en_statsinvitessent2 = /** @type {(inputs: Statsinvitessent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

const de_statsinvitessent2 = /** @type {(inputs: Statsinvitessent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendet`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Statsinvitessent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsinvitessent2 = /** @type {((inputs?: Statsinvitessent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsinvitessent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsinvitessent2(inputs)
	return de_statsinvitessent2(inputs)
});
export { statsinvitessent2 as "statsInvitesSent" }